import React from "react";

const ChillerVanWhyChoose = ({ title, description, reasons }) => {
  return (
    <section className="cv-why-section">
      <div className="container">
        <div
          className="text-center"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-once="true"
        >
          <h2 className="mb-3">{title}</h2>
          <p className="mx-auto" >{description}</p>
        </div>

        <div className="row g-4 mt-2">
          {reasons.map((reason, i) => (
            <div
              key={i}
              className="col-sm-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay={`${i * 100}`}
              data-aos-duration="700"
              data-aos-once="true"
            >
              <div className="cv-why-card">
                <i className={`bi ${reason.icon} cv-why-icon`}></i>
                <p className="cv-why-card-title">{reason.title}</p>
                <p>{reason.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChillerVanWhyChoose;
